const shareBtn = document.getElementsByClassName('btn--share');
const clipboardBtn = document.getElementsByClassName('btn--clipboard');

for(let i = 0, length1 = shareBtn.length; i < length1; i++){
    shareBtn[i].onclick = function(event){
        let target = this.getAttribute('data-href');

        const a = document.createElement("a")
        a.href = (this.getAttribute('data-href')) ? this.getAttribute('data-href') : "#";
        a.target = "_blank";
        a.target = "noopener";
        a.click();
    }
}

for(let j = 0, length1 = clipboardBtn.length; j < length1; j++){
     clipboardBtn[j].onclick = function(event){

        let spanTag = document.createElement('span');
        let linkString = this.getAttribute('data-url');

        // Copy to clipboard the old way fashion way. New way not fully supported yet. Revisit later?

        const el = document.createElement('textarea');
            el.value = linkString;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);

        spanTag.appendChild(document.createTextNode('Copied!'))
        spanTag.classList.add('copied');
        spanTag.classList.add('animate');

        spanTag.addEventListener("animationend", function(e){
            if(e.type == "animationend"){
                spanTag.remove();
                animating = false;
            }
        }, false);

        this.appendChild(spanTag);
     }
}